import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { FormHelper } from '../../helpers/form-helper';
import { FbError } from '../../models/fbError';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;

  constructor(private authService: AuthService,
							private formBuilder: FormBuilder,
							private route: ActivatedRoute,
							private router: Router) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();
	}

  ngOnInit() {
		this.subscriptionManager.add(this.route
      .queryParams
      .subscribe(next => {
        this.form.controls['code'].setValue(next['oobCode'] || '');
      }));
  }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			code: new FormControl('', [
				Validators.required
			]),
			password: new FormControl('', [
				Validators.required
			])
		});
	}

	public async submitForm(): Promise<any> {
		try
		{
			let code: string = this.form.value.code;
			let password: string = this.form.value.password;

			await this.authService.changePassword(code, password);

			this.submitError = '';
			this.router.navigate(['login']);
		}
		catch(ex)
		{
			let error = ex as FbError;

			switch (error.code) {
				case 'auth/expired-action-code':
					this.submitError = 'El código ha expirado';
					break;

				case 'auth/invalid-action-code':
					this.submitError = 'El código es inválido';
					break;

				case 'auth/user-disabled':
					this.submitError = 'El usuario está deshabilitado';
					break;

				case 'auth/user-not-found':
					this.submitError = 'El usuario no ha sido encontrado';
					break;

				case 'auth/weak-password':
					this.submitError = 'La contraseña es muy débil';
					break;

				default:
					this.submitError = 'Ocurrió un error al cambiar la contraseña';
					break;
			}
		}
  }
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/change-password/change-password.component.ts